export function backboneTranslate(input: string, dict_field: string) {
    if(!input)
        return null;
    const backboneDict:any = {
        "other": {"vector":	0, "shorthand":	"other", "promoter": "none", "reporter":	"none", "transgenesisType": "none"},
        "Hsp68_LacZ": {"vector":	1, "shorthand":	"hZR", "promoter": "Hsp68", "reporter":	"lacZ", "transgenesisType": "random"},
        "Hsp68_LacZ@H11": {"vector":	2, "shorthand":	"hZH", "promoter": "Hsp68", "reporter":	"lacZ", "transgenesisType": "targeted (H11)"},
        "Shh_LacZ@H11": {"vector":	3, "shorthand":	"sZH", "promoter": "Shh", "reporter":	"lacZ", "transgenesisType": "targeted (H11)"},
        "Betaglobin_LacZ@H11": {"vector":	4, "shorthand":	"gZH", "promoter": "Betaglobin (short)", "reporter":	"lacZ", "transgenesisType": "targeted (H11)"},
        "Shh_Venus@H11": {"vector":	5, "shorthand":	"sVH", "promoter": "Shh", "reporter":	"Venus", "transgenesisType": "targeted (H11)"},
        "Hsp68_Venus@H11": {"vector":	6, "shorthand":	"hVH", "promoter": "Hsp68", "reporter":	"Venus", "transgenesisType": "targeted (H11)"},
        "Shh_mCherry@H11": {"vector":	7, "shorthand":	"sCH", "promoter": "Shh", "reporter":	"mCherry", "transgenesisType": "targeted (H11)"},
        "Hsp68_mCherry@H11": {"vector":	8, "shorthand":	"hCH", "promoter": "Hsp68", "reporter":	"mCherry", "transgenesisType": "targeted (H11)"},
        "Hsp68_mCherry": {"vector":	9, "shorthand":	"hCR", "promoter": "Hsp68", "reporter":	"mCherry", "transgenesisType": "random"},
        "Hsp68_GFP-SUN1": {"vector":	10, "shorthand":	"hGS", "promoter": "Hsp68", "reporter":	"GFP-SUN1", "transgenesisType": "random"},
        "Hsp68_LacZ-tdTomato": {"vector":	11, "shorthand":	"hZTR", "promoter": "Hsp68", "reporter":	"lacZ-tdTomato", "transgenesisType": "random"},
        "Betaglobin_LacZ": {"vector":	12, "shorthand":	"gZR", "promoter": "Betaglobin (short)", "reporter":	"lacZ", "transgenesisType": "random"},
        "Shh_LacZ-T2A-mCherry@H11": {"vector":	13, "shorthand":	"sLCH", "promoter": "Shh", "reporter":	"lacZ-mCherry", "transgenesisType": "targeted (H11)"},
        "LacZ@H11": {"vector":	14, "shorthand":	"nZH", "promoter": "none", "reporter":	"lacZ", "transgenesisType": "targeted (H11)"},
        "Betaglobin2_LacZ@H11": {"vector":	15, "shorthand":	"gZH2", "promoter": "Betaglobin (long)", "reporter":	"lacZ", "transgenesisType": "targeted (H11)"},
        "Hsp68_mCherry@H11_2": {"vector":	16, "shorthand":	"hCH2", "promoter": "Hsp68", "reporter":	"mCherry", "transgenesisType": "targeted (H11)"},
        "Betaglobin2_mNeon@H11": {"vector":	17, "shorthand":	"gNH2", "promoter": "Betaglobin (long)", "reporter":	"mNeon", "transgenesisType": "targeted (H11)"},
        "Betaglobin2_mCherry@H11": {"vector":	18, "shorthand":	"gCH2", "promoter": "Betaglobin (long)", "reporter":	"mCherry", "transgenesisType": "targeted (H11)"},
        "Betaglobin2_mTurquoise2@H11": {"vector":	19, "shorthand":	"gTH2", "promoter": "Betaglobin (long)", "reporter":	"mTurquoise2", "transgenesisType": "targeted (H11)"},
                  
        "hZR": {"vector": 1, "shorthand": "hZR", "promoter": "Hsp68", "reporter": "lacZ", "transgenesisType": "random"},
        "hZH": {"vector": 2, "shorthand": "hZH", "promoter": "Hsp68", "reporter": "lacZ", "transgenesisType": "targeted (H11)"},
        "sZH": {"vector": 3, "shorthand": "sZH", "promoter": "Shh", "reporter": "lacZ", "transgenesisType": "targeted (H11)"},
        "gZH": {"vector": 4, "shorthand": "gZH", "promoter": "Betaglobin (short)", "reporter": "lacZ", "transgenesisType": "targeted (H11)"},
        "sVH": {"vector": 5, "shorthand": "sVH", "promoter": "Shh", "reporter": "Venus", "transgenesisType": "targeted (H11)"},
        "hVH": {"vector": 6, "shorthand": "hVH", "promoter": "Hsp68", "reporter": "Venus", "transgenesisType": "targeted (H11)"},
        "sCH": {"vector": 7, "shorthand": "sCH", "promoter": "Shh", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "hCH": {"vector": 8, "shorthand": "hCH", "promoter": "Hsp68", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "hCR": {"vector": 9, "shorthand": "hCR", "promoter": "Hsp68", "reporter": "mCherry", "transgenesisType": "random"},
        "hGSR": {"vector": 10, "shorthand": "hGSR", "promoter": "Hsp68", "reporter": "GFP-SUN1", "transgenesisType": "random"},
        "hZTR": {"vector": 11, "shorthand": "hZTR", "promoter": "Hsp68", "reporter": "lacZ-tdTomato", "transgenesisType": "random"},
        "gZR": {"vector": 12, "shorthand": "gZR", "promoter": "Betaglobin (short)", "reporter": "lacZ", "transgenesisType": "random"},
        "sLCH": {"vector": 13, "shorthand": "sLCH", "promoter": "Shh", "reporter": "lacZ-mCherry", "transgenesisType": "targeted (H11)"},
        "nZH": {"vector": 14, "shorthand": "nZH", "promoter": "none", "reporter": "lacZ", "transgenesisType": "targeted (H11)"},
        "gZH2": {"vector": 15, "shorthand": "gZH2", "promoter": "Betaglobin (long)", "reporter": "lacZ", "transgenesisType": "targeted (H11)"},
        "hCH2": {"vector": 16, "shorthand": "hCH2", "promoter": "Hsp68", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "gNH2": {"vector": 17, "shorthand": "gNH2", "promoter": "Betaglobin (long)", "reporter": "mNeon", "transgenesisType": "targeted (H11)"},
        "gCH2": {"vector": 18, "shorthand": "gCH2", "promoter": "Betaglobin (long)", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "gTH2": {"vector": 19, "shorthand": "gTH2", "promoter": "Betaglobin (long)", "reporter": "mTurquoise2", "transgenesisType": "targeted (H11)"},
        "hCH3": {"vector": 20, "shorthand": "hCH3", "promoter": "Hsp68", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "sCH3": {"vector": 21, "shorthand": "sCH3", "promoter": "Shh", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "gCH3": {"vector": 22, "shorthand": "gCH3", "promoter": "Betaglobin (long)", "reporter": "mCherry", "transgenesisType": "targeted (H11)"},
        "hNH": {"vector": 23, "shorthand": "hNH", "promoter": "Hsp68", "reporter": "mNeonGreen", "transgenesisType": "targeted (H11)"},
        "sNH": {"vector": 24, "shorthand": "sNH", "promoter": "Shh", "reporter": "mNeonGreen", "transgenesisType": "targeted (H11)"}    			
      };

      return backboneDict[input][dict_field];
}


export function tissueTranslate(input: string, dict_field: string) {
    if(!input)
        return null;
    const defaultTissueNames:any = {
        'bv':{ name: 'Blood_Vessels', label: 'Blood vessels', short:'blood-vessels', abb:'bv' },
        'ba':{ name: 'Branchial_Arch', label: 'Branchial arch', short:'branchial-arch', abb:'ba' },
        'cn':{ name: 'Cranial_Nerve', label: 'Cranial nerve', short:'cranial-nerve', abb:'cn' },
        'drg':{ name: 'Dorsal_Root_Ganglion', label: 'Dorsal root ganglion', short:'drg', abb:'drg' },
        'ear':{ name: 'Ear', label: 'Ear', short:'ear', abb:'ear' },
        'eye':{ name: 'Retina', label: 'Eye', short:'eye', abb:'eye' },
        'fm':{ name: 'Face', label: 'Facial mesenchyme', short:'face-mesen', abb:'fm' },
        'fb':{ name: 'Forebrain', label: 'Forebrain', short:'forebrain', abb:'fb' },
        'gen':{ name: 'Genital_Tubercle', label: 'Genital tubercle', short:'genital', abb:'gen' },
        'ht':{ name: 'Heart', label: 'Heart', short:'heart', abb:'ht' },
        'hb':{ name: 'Hindbrain', label: 'Hindbrain', short:'hindbrain', abb:'hb' },
        'lb':{ name: 'Limbs', label: 'Limb', short:'limb', abb:'lb' },
        'lv':{ name: 'Liver', label: 'Liver', short:'liver', abb:'lv' },
        'mel':{ name: 'Melanocytes', label: 'Melanocytes', short:'melanocytes', abb:'mel' },
        'mnc':{ name: 'Neural_Mesenchyme', label: 'Neural Crest Mesenchyme', short:'crest-mesen', abb:'mnc' },
        'mb':{ name: 'Midbrain', label: 'Midbrain', short:'midbrain', abb:'mb' },
        'nt':{ name: 'Neural_Tube', label: 'Neural tube', short:'neural-tube', abb:'nt' },
        'nose':{ name: 'Nose', label: 'Nose', short:'nose', abb:'nose' },
        'other':{ name: 'Other', label: 'Other', short:'other', abb:'other' },
        'pan':{ name: 'Pancreas', label: 'Pancreas', short:'pancreas', abb:'pan' },
        'som':{ name: 'Somite', label: 'Somite', short:'somite', abb:'som' },
        'tail':{ name: 'Tail', label: 'Tail', short:'tail', abb:'tail' },
        'tri':{ name: 'Trigeminal_V', label: 'Trigeminal V (ganglion, cranial)', short:'trigeminal', abb:'tri' }
    };
    if(defaultTissueNames[input])
        return defaultTissueNames[input][dict_field];
    else
        return input;
}

export function relTissueTranslate(input: string) {
    if(!input)
        return null;
    const relTissueNames:any = {
        'lof': 'Loss of function',
        'plof': 'Partial loss of function',
        'gof': 'Gain of function',
        'nc': 'No change',
        'nd': 'Not determined',
        'cmpx': 'complex'
    };

    return relTissueNames[input];
}

export function allelicBasisTranslate(input: string) {
    if(!input) {
        return "No Genotype";
    }
    const allelicBasis:any= {
        "T+S": "Tandem & Single",
        "T": "Tandem",
        "S": "Single",
        "all_tg": 'All TG'
    };
    return allelicBasis[input];
}